import ky from 'ky';

export async function uploadImage (base64Image) {
  return ky.post( '/.netlify/functions/uploadImage', { body: base64Image }).json();
}

